import { Grid, Icon, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { PrimaryButton } from "../../_components/button/primary.button";
import { stringToDateFormat } from "../../_helpers/format.helper";
import { accountService } from "../../_services/accounts.service";
import { officialTrainingInformationService } from "../../_services/officialTrainingInformation.service";

export function UserTrainingView() {

    const { userId } = useParams<{ userId: string }>();

    let navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [initQuantity, setInitQuantity] = useState(0);
    const [isSaving, setIsSaving] = useState(false);
    const [data, setData] = useState<Array<any>>([]);

    useEffect(() => {
        fetchData(userId || accountService.currentUserValue.id);
    }, []);

    function fetchData(id: string) {

        setIsLoading(true)
        return officialTrainingInformationService
            .get(userId || "")
            .then(
                (json: any) => {
                    if (json && json.length) {
                        setInitQuantity(json.length)
                        json.forEach((j: any) => {
                            j.trainingDate = stringToDateFormat(j.trainingDate)
                        })
                    }
                    setData(json);
                }, () => {

                }
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <>
            {!isLoading && data &&
                <Paper>
                    <ValidatorForm
                        onSubmit={() => { }}
                        noValidate>

                        <Grid container spacing={2} sx={{ mt: 0 }}>

                            <Grid item xs={12}>
                                <Typography variant="h6" textAlign="center">Training Information</Typography>
                            </Grid>

                            {(accountService.isAdmin) &&
                                <Grid item xs={12}>
                                    <PrimaryButton
                                        type="button"
                                        variant="primary"
                                        onClick={() => { setData((_data) => ([..._data, {}])) }} >
                                        <Icon>add</Icon> Add Another Training Information
                                    </PrimaryButton>
                                </Grid>
                            }

                            {(!data || !(data.length > 0 || initQuantity > 0)) &&
                                <Grid item xs={12}>
                                    <p>No Official Training Information</p>
                                </Grid>
                            }

                            {(data && data.length > 0) && data.map((d: any, index: number) =>
                                <>
                                    <Grid item xs={accountService.isAdmin ? 6 : 7}>
                                        <TextValidator
                                            key={index + "trainingInfo"}
                                            label="Training Info"
                                            value={data[index].trainingInfo}
                                            name="trainingInfo"
                                            required
                                            disabled={!accountService.isAdmin}
                                            fullWidth
                                            validators={['required']}
                                            errorMessages={['This field is required']}
                                            onChange={(event) => {
                                                setData((_data: any) => {
                                                    {
                                                        var __data = [..._data];
                                                        __data[index].trainingInfo = (event.target as any).value;
                                                        return __data;
                                                    }
                                                })
                                            }}
                                            InputLabelProps={{
                                                shrink: d[index]?.trainingInfo,
                                            }}
                                            variant="filled"
                                        />
                                    </Grid>
                                    <Grid item xs={accountService.isAdmin ? 4 : 5}>
                                        <TextValidator
                                            key={index + "trainingDate"}
                                            label="Training Date"
                                            value={data[index].trainingDate}
                                            name="trainingDate"
                                            required
                                            fullWidth
                                            type="date"
                                            disabled={!accountService.isAdmin}
                                            validators={['required']}
                                            errorMessages={['This field is required']}
                                            onChange={(event) => {
                                                setData((_data: any) => {
                                                    {
                                                        var __data = [..._data];
                                                        __data[index].trainingDate = stringToDateFormat((event.target as any).value);
                                                        return __data;
                                                    }
                                                })
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="filled"
                                        />
                                    </Grid>

                                </>
                            )}


                        </Grid>

                    </ValidatorForm >
                </Paper>
            }
        </>
    );

}
